import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAskNavigator = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 26,
		height: 26,
		rx: 13,
		fill: "#0DAAF4"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.4733 18.5267L16.9999 16.0734C17.96 14.8763 18.4249 13.3569 18.2991 11.8276C18.1733 10.2983 17.4664 8.87525 16.3236 7.85115C15.1808 6.82706 13.6891 6.27973 12.1552 6.32171C10.6213 6.36368 9.16175 6.99177 8.0767 8.07682C6.99164 9.16187 6.36356 10.6214 6.32158 12.1553C6.27961 13.6893 6.82694 15.181 7.85103 16.3237C8.87512 17.4665 10.2981 18.1735 11.8275 18.2993C13.3568 18.4251 14.8762 17.9601 16.0733 17.0001L18.5266 19.4534C18.5886 19.5159 18.6623 19.5655 18.7436 19.5993C18.8248 19.6332 18.9119 19.6506 18.9999 19.6506C19.0879 19.6506 19.1751 19.6332 19.2563 19.5993C19.3376 19.5655 19.4113 19.5159 19.4733 19.4534C19.5934 19.3291 19.6606 19.163 19.6606 18.9901C19.6606 18.8172 19.5934 18.651 19.4733 18.5267ZM12.3333 17.0001C11.4103 17.0001 10.508 16.7264 9.74061 16.2136C8.97318 15.7008 8.37504 14.972 8.02183 14.1192C7.66862 13.2665 7.57621 12.3282 7.75627 11.423C7.93634 10.5177 8.38079 9.6862 9.03344 9.03356C9.68608 8.38091 10.5176 7.93646 11.4228 7.75639C12.3281 7.57633 13.2664 7.66874 14.1191 8.02195C14.9718 8.37516 15.7007 8.9733 16.2135 9.74073C16.7262 10.5082 16.9999 11.4104 16.9999 12.3334C16.9999 13.5711 16.5083 14.7581 15.6331 15.6332C14.7579 16.5084 13.5709 17.0001 12.3333 17.0001Z",
		fill: "#FAFFFE"
	})]
});
export default SvgAskNavigator;
